var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderMiniIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.329 8.25573V6.91406H7.67067V8.25573H6.329ZM3.99567 8.25573V6.91406H5.33734V8.25573H3.99567ZM8.66234 8.25573V6.91406H10.004V8.25573H8.66234ZM6.329 10.5891V9.2474H7.67067V10.5891H6.329ZM3.99567 10.5891V9.2474H5.33734V10.5891H3.99567ZM8.66234 10.5891V9.2474H10.004V10.5891H8.66234ZM1.38525 13.1995V1.66406H3.57275V0.789062H4.76859V1.66406H9.23109V0.789062H10.4269V1.66406H12.629V13.1995H1.38525ZM2.75609 11.8286H11.2436V5.68906H2.75609V11.8286ZM2.75609 4.81406H11.2436V3.04948H2.75609V4.81406ZM2.75609 4.81406V3.04948V4.81406Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderMiniIcon);
export default __webpack_public_path__ + "static/media/calender_mini_icon.48b6b5dc7feb7e38f7eecd2e2efbefe3.svg";
export { ForwardRef as ReactComponent };